<sd-ymap class="map" (created)="onMapCreated($event)"></sd-ymap>

@if (isTabletMdDown()) {
  <div class="map-zoom-controls">
    <button type="button" class="btn-icon zoom-button" title="+" (click)="onMapZoom('IN')">
      <sd-icon [type]="iconType.PLUS" class="icon-size-s icon-size-md-m"></sd-icon>
    </button>
    <button type="button" class="btn-icon zoom-button" title="-" (click)="onMapZoom('OUT')">
      <sd-icon [type]="iconType.MINUS" class="icon-size-s icon-size-md-m"></sd-icon>
    </button>
    <button type="button" class="btn-icon zoom-button" title="-" (click)="onMapGetGeolocation()">
      <sd-icon [type]="iconType.LOCATION" class="icon-size-s icon-size-md-m"></sd-icon>
    </button>
  </div>
}
